module.exports = "/_next/static/images/contact-9dddb8d41cc180a3aad53d1d56565bee.png";